import { Link, useParams } from "react-router-dom";
import { getCatalogEntry, getJourney } from "@seeing-maths/content-runtime";
import { STAGE_IDS, type StageId } from "@seeing-maths/contracts";
import { MysteryNumberJourney } from "../journeys/mystery-number-journey";

export function JourneyPage() {
  const { journeyId = "", stageId = "" } = useParams();
  const catalog = getCatalogEntry(journeyId);
  const journey = getJourney(journeyId);
  const validStage = STAGE_IDS.includes(stageId as StageId);

  if (!catalog || !validStage) {
    return (
      <main className="simple-page not-found">
        <p className="page-kicker">OFF THE MAP</p>
        <h1>This journey route is not valid.</h1>
        <Link className="btn btn-primary" to="/atlas">Return to the Atlas</Link>
      </main>
    );
  }

  if (!journey) {
    return (
      <main className="simple-page migration-page">
        <p className="page-kicker">JOURNEY {String(catalog.number).padStart(2, "0")} · {catalog.world}</p>
        <h1>{catalog.title}</h1>
        <div className="migration-page-card card">
          <span className="migration-glyph" aria-hidden="true">{catalog.glyph}</span>
          <div>
            <h2>This path is still forming</h2>
            <p>Its artifacts are not ready to enter yet. Return to the Atlas and choose an open path.</p>
          </div>
        </div>
        <Link className="btn btn-primary" to="/atlas">Return to the Atlas</Link>
      </main>
    );
  }

  return <MysteryNumberJourney definition={journey} requestedStage={stageId as StageId} />;
}
